import Quill from "quill";
const Inline = Quill.import("blots/inline");

class PassiveVoiceBlot extends Inline {
  static create(message) {
    const node = super.create();
    node.setAttribute("title", message || "Passive voice detected");
    return node;
  }

  static formats(node) {
    return node.getAttribute("title");
  }
}

PassiveVoiceBlot.blotName = "passive-voice";
PassiveVoiceBlot.tagName = "span";
PassiveVoiceBlot.className = "passive-voice";

Quill.register(PassiveVoiceBlot);
